var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStoriesShareTwitter = function SvgStoriesShareTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M23.407 5.334c-.814.363-1.5.375-2.228.016.938-.562.981-.957 1.32-2.019-.878.521-1.851.9-2.886 1.104a4.545 4.545 0 0 0-7.742 4.145 12.9 12.9 0 0 1-9.366-4.748 4.5 4.5 0 0 0-.615 2.285c0 1.577.803 2.967 2.021 3.782a4.5 4.5 0 0 1-2.057-.568l-.001.057a4.55 4.55 0 0 0 3.646 4.456 4.6 4.6 0 0 1-2.053.079 4.55 4.55 0 0 0 4.245 3.155 9.14 9.14 0 0 1-6.728 1.881A12.87 12.87 0 0 0 7.929 21c8.358 0 12.928-6.924 12.928-12.929q0-.296-.012-.588c.886-.64 1.953-1.237 2.562-2.149Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h24v24H0z"
  }))));
};
export default SvgStoriesShareTwitter;